// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "public/css/" + chunkId + "." + {"5":"71211d32","267":"73f4ec82","444":"60af513d","599":"322c8942","955":"2f6f84f6"}[chunkId] + ".css";
};